import toolPalete from './toolColors';
import toolPaletteA11y from './toolColorsA11y';
import b4bTheme from './b4b-theme';
import a11yOverrides from './b4b-theme-a11y';
import variables from './variables';
import variablesA11y from './variables-a11y';

function getToolColor(index = 0, offset = 0) {
  const position = (index + offset) % toolPalete.length;
  return toolPalete[position];
}

function getToolColorA11y(index = 0, offset = 0) {
  const position = (index + offset) % toolPaletteA11y.length;
  return toolPaletteA11y[position];
}

function createTheme(theme) {
  return {
    getToolColor,
    ...variables,
    ...theme,
  };
}

function createA11yTheme(theme) {
  return {
    getToolColor: getToolColorA11y,
    ...variables,
    ...variablesA11y,
    ...theme,
  };
}

const mergeTheme = (base, customization) => ({
  ...base,
  primaryColor: customization.primary_color || base.primaryColor,
  secondaryColor: customization.secondary_color || base.primaryColor,
});

function createA11yVariant(baseTheme, a11yColors, type) {
  return { ...createA11yTheme({ ...baseTheme, ...a11yColors }), type };
}

const memberb4bTheme = {
  primaryColor: b4bTheme.memberGreen,
  primaryColorHover: b4bTheme.memberGreenHover,
  primaryColorFade: b4bTheme.memberGreenFade,
  primaryColorBgFade: b4bTheme.memberGreenBgFade,
};
const mentorb4bTheme = {
  primaryColor: b4bTheme.mentorBlue,
  primaryColorHover: b4bTheme.mentorBlueHover,
  primaryColorFade: b4bTheme.mentorBlueFade,
  primaryColorBgFade: b4bTheme.mentorBlueBgFade,
};
const parrotb4bTheme = {
  primaryColor: b4bTheme.parrotPink,
  primaryColorHover: b4bTheme.parrotPinkHover,
  primaryColorFade: b4bTheme.parrotPinkFade,
  primaryColorBgFade: b4bTheme.parrotPinkBgFade,
};
const parrotChatTheme = parrotb4bTheme;
const errorb4bTheme = {
  primaryColor: b4bTheme.error,
  primaryColorHover: b4bTheme.errorFade,
  primaryColorFade: b4bTheme.errorFade,
  primaryColorBgFade: b4bTheme.errorFade,
};

const TYPE_MAIN = 'main';
const TYPE_MEMBER = 'member';
const TYPE_MENTOR = 'mentor';
const TYPE_PARROT = 'parrot';
const TYPE_PARROBOT_CHAT = 'parrobot_chat';
const TYPE_ERROR = 'error';

const mainTheme = { ...createTheme(b4bTheme), type: TYPE_MAIN };
const memberTheme = { ...createTheme(memberb4bTheme), type: TYPE_MEMBER };
const mentorTheme = { ...createTheme(mentorb4bTheme), type: TYPE_MENTOR };
const parrotTheme = { ...createTheme(parrotb4bTheme), type: TYPE_PARROT };
const parrobotChatTheme = { ...createTheme(parrotChatTheme), type: TYPE_PARROBOT_CHAT };
const errorTheme = { ...createTheme(errorb4bTheme), type: TYPE_ERROR };

// High-contrast (a11y) theme variants
const a11yB4bTheme = { ...b4bTheme, ...a11yOverrides };
const mainThemeA11y = { ...createA11yTheme(a11yB4bTheme), type: TYPE_MAIN };
const memberA11yColors = {
  primaryColor: a11yOverrides.memberGreen,
  primaryColorHover: a11yOverrides.memberGreenHover,
  primaryColorFade: a11yOverrides.memberGreenFade,
  primaryColorBgFade: a11yOverrides.memberGreenBgFade,
};
const mentorA11yColors = {
  primaryColor: a11yOverrides.mentorBlue,
  primaryColorHover: a11yOverrides.mentorBlueHover,
  primaryColorFade: a11yOverrides.mentorBlueFade,
  primaryColorBgFade: a11yOverrides.mentorBlueBgFade,
};
const parrotA11yColors = {
  primaryColor: a11yOverrides.parrotPink,
  primaryColorHover: a11yOverrides.parrotPinkHover,
  primaryColorFade: a11yOverrides.parrotPinkFade,
  primaryColorBgFade: a11yOverrides.parrotPinkBgFade,
};
const errorA11yColors = {
  primaryColor: a11yOverrides.error,
  primaryColorHover: a11yOverrides.errorHover,
  primaryColorFade: a11yOverrides.errorFade,
  primaryColorBgFade: a11yOverrides.errorFade,
};
const memberThemeA11y = createA11yVariant(memberb4bTheme, memberA11yColors, TYPE_MEMBER);
const mentorThemeA11y = createA11yVariant(mentorb4bTheme, mentorA11yColors, TYPE_MENTOR);
const parrotThemeA11y = createA11yVariant(parrotb4bTheme, parrotA11yColors, TYPE_PARROT);
const parrobotChatThemeA11y = createA11yVariant(parrotChatTheme, parrotA11yColors, TYPE_PARROBOT_CHAT);
const errorThemeA11y = createA11yVariant(errorb4bTheme, errorA11yColors, TYPE_ERROR);

function getParrotTheme(highContrastMode) {
  return highContrastMode ? parrotThemeA11y : parrotTheme;
}

function getMemberTheme(highContrastMode) {
  return highContrastMode ? memberThemeA11y : memberTheme;
}

function getMentorTheme(highContrastMode) {
  return highContrastMode ? mentorThemeA11y : mentorTheme;
}

function getMainTheme(highContrastMode) {
  return highContrastMode ? mainThemeA11y : mainTheme;
}

function getToolColorFunction(highContrastMode) {
  return highContrastMode ? getToolColorA11y : getToolColor;
}

export {
  getToolColor,
  getToolColorA11y,
  getParrotTheme,
  getMemberTheme,
  getMentorTheme,
  getMainTheme,
  getToolColorFunction,
  mainTheme,
  memberTheme,
  mentorTheme,
  mergeTheme,
  parrotTheme,
  parrobotChatTheme,
  errorTheme,
  mainThemeA11y,
  memberThemeA11y,
  mentorThemeA11y,
  parrotThemeA11y,
  parrobotChatThemeA11y,
  errorThemeA11y,
  TYPE_MAIN,
  TYPE_MEMBER,
  TYPE_MENTOR,
};
